import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    borderBottom: `0.1px solid ${mainColor.colorAdditional}`
  },
  itemtext: { paddingLeft: UNIT * 0.3125 },
  listItem: { width: UNIT * 13.75 },
  title: {
    fontSize: UNIT * 1.25,
    padding: UNIT * 0.3125,
    color: 'gray'
  },
  icon: {
    maginLeft: UNIT * 1.25,
    backgroundColor: `rgba(${mainColor.rgb}, 0.8)`
  },
  inputStyle: { width: '100%' },
  contentStyle: {
    padding: UNIT,
    paddingBottom: 0
  },
  contactStyle: { paddingRight: UNIT * 1.25, marginTop: 0 },
  textStyle: { fontSize: UNIT, marginLeft: UNIT * 0.625, marginRight: UNIT * 0.625 },
  boldText: {
    fontSize: UNIT,
    fontWeight: 'bolder'
  },
  space: {
    marginBottom: `-${UNIT}px!important`
  }
});
